export default __webpack_public_path__ + "static/media/photo--sm--kara4.c3b247c0.jpg";